<template>
  <div>
    <serviceList
      :pageTitle="$t('internationShippingPage.featureTitle')"
      :titleDesc="$t('internationShippingPage.featureText')"
      :bannerUrl="bannerUrl"
      :characterList="characterList"
      :imgTextList="imgTextList"
      isRightPostion
    />
  </div>
</template>

<script setup>
import serviceList from '../../components/template/serviceList.vue';
import { useI18n } from 'vue-i18n'; 
const { t } = useI18n();
const bannerUrl = require('@assets/images/banner/banner-international-shipping.png');
const characterList = [
  {
    img: require('@assets/icons/ico-feature_1.svg'),
    title: t('internationShippingPage.feature1.title'),
    text: t('internationShippingPage.feature1.text'),
  },
  {
    img: require('@assets/icons/ico-feature_2.svg'),
    title: t('internationShippingPage.feature2.title'),
    text: t('internationShippingPage.feature2.text'),
  },
  {
    img: require('@assets/icons/ico-feature_3.svg'),
    title: t('internationShippingPage.feature3.title'),
    text: t('internationShippingPage.feature3.text'),
  },
]
const imgTextList = [
  {
    img: require('@assets/images/interational_shipping_img_1.png'),
    title: t('internationShippingPage.description1.title'),
    text: t('internationShippingPage.description1.text'),
  },
  {
    img: require('@assets/images/interational_shipping_img_2.png'),
    title: t('internationShippingPage.description2.title'),
    text: t('internationShippingPage.description2.text'),
  },
]
</script>